"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeWithName = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _internal = require("../../../../hooks/internal");
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ShadeWithName = () => {
  const {
    code,
    shades,
    isMultiShade
  } = (0, _internal.useProduct)();
  const currentShade = (0, _react.useMemo)(() => shades?.find(shade => shade.productCode === code), [code, shades]);
  if (!currentShade?.shadeName || !isMultiShade) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadeWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Shade, {
        shade: {
          canBeSold: true,
          ...currentShade
        },
        size: _presentationComponents.ShadeSize.Small,
        testId: _constants.PRODUCT_BOX_SHADE_TEST_ID
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
      variant: "caption",
      children: currentShade.shadeName
    })]
  });
};
exports.ShadeWithName = ShadeWithName;
